import { sendSmsCode } from '@/api/user'
import { Message } from 'element-ui'
import { getSmsTimer, setSmsTimer, countSmsTimer } from '@/store/local/misc'

const getDefaultState = () => {
  return {
    sendSmsCodeTimer: getSmsTimer()?getSmsTimer():0
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_SMS_CODE_TIMER: (state) => {
    state.sendSmsCodeTimer = setSmsTimer(60)
  },
  COUNT_SMS_CODE_TIMER: (state) => {
    if (state.sendSmsCodeTimer > 0) state.sendSmsCodeTimer = countSmsTimer()
  }
}

const actions = {
  startCountThread({ commit }) {
    return new Promise((resolve, reject) => {
      const intervalId = setInterval(() => {
        if (state.sendSmsCodeTimer > 0) commit('COUNT_SMS_CODE_TIMER')
        else clearInterval(intervalId)
      }, 1000)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  sendSmsCode({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      sendSmsCode(data).then(response => {
        const { data } = response
        if (data.code == 1){
          commit('SET_SMS_CODE_TIMER')
          dispatch('startCountThread')
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

